module.exports = __webpack_public_path__ + "media/images/slide-12-542320c6be18c864f7164596efa7a234.jpg";